// extracted by mini-css-extract-plugin
module.exports = {"value__texts":"SingleCharacteristic_value__texts__EeuVS","value":"SingleCharacteristic_value__RBHV6","value__hr":"SingleCharacteristic_value__hr__fqrPs"};